export type PostingWindow = "morning" | "afternoon" | "evening" | "late";

export function getSlotDateTime(baseDate: Date, slot: PostingWindow): string {
  const date = new Date(baseDate);
  const slotHours: Record<PostingWindow, number> = {
    morning: 9,
    afternoon: 13,
    evening: 18,
    late: 21,
  };
  date.setHours(slotHours[slot], 0, 0, 0);
  return date.toISOString();
}

export function formatDateTimeInput(iso?: string | null) {
  const date = iso ? new Date(iso) : new Date();
  const tzOffset = date.getTimezoneOffset();
  date.setMinutes(date.getMinutes() - tzOffset);
  return date.toISOString().slice(0, 16);
}

export function formatRelativeTime(iso: string) {
  const delta = Date.now() - new Date(iso).getTime();
  const minutes = Math.max(1, Math.round(Math.abs(delta) / (1000 * 60)));
  if (minutes < 60) {
    return `${minutes} min ago`;
  }
  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    return `${hours} hr${hours > 1 ? "s" : ""} ago`;
  }
  const days = Math.floor(hours / 24);
  return `${days} day${days > 1 ? "s" : ""} ago`;
}
